export default __webpack_public_path__ + "static/IMG_9271-58c148df1d89bb950387670f483f22b7.jpg";